import { render, staticRenderFns } from "./Taxation.vue?vue&type=template&id=ece02638&scoped=true&"
import script from "./Taxation.vue?vue&type=script&lang=js&"
export * from "./Taxation.vue?vue&type=script&lang=js&"
import style0 from "./Taxation.vue?vue&type=style&index=0&id=ece02638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece02638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece02638')) {
      api.createRecord('ece02638', component.options)
    } else {
      api.reload('ece02638', component.options)
    }
    module.hot.accept("./Taxation.vue?vue&type=template&id=ece02638&scoped=true&", function () {
      api.rerender('ece02638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/select/Taxation.vue"
export default component.exports